var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgMint2M(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M16.3 2.5H8.5V3.5H7.5V4.5H6.5V5.5H5.5V11.7H6.5V12.7002H7.5V13.7002H8.5V14.7002H9.3V17.5H9.29999V20.5H10.3V21.5H14.5V20.5H15.5V14.7H16.3V13.7H17.3V12.7H18.3V11.7H19.3V5.5H18.3V4.5H17.3V3.5H16.3V2.5ZM15.3 4.5H9.5V5.5H8.5V6.5H7.5V10.7002H8.5V11.7002H9.5V12.7002H11.3V16.5H12.3V18.5H11.3V19.5H13.5V12.7H15.3V11.7H16.3V10.7H17.3V6.5H16.3V5.5H15.3V4.5ZM13.9 6.09961H10.9V6.89961H10.1V9.89961H10.9V10.6996H13.9V9.89961H14.7V6.89961H13.9V6.09961Z",
    fill: "currentColor"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgMint2M);
export default __webpack_public_path__ + "static/media/mint2-m.919adf42c8c90cb06612c4ceedc06b33.svg";
export { ForwardRef as ReactComponent };